import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';
import lockIcon from '../../assets/lock.svg';
import finvuLogo from '../../assets/FinvuWordmark.svg';

const Footer = (props) => {
	const { t } = useTranslation();
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));

	return (
		<Box
			sx={{
				display: 'flex',
				gap: '10px',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '10px 20px',
				backgroundColor: '#F5F5F5',
				borderTop: '1px solid #E0E0E0',
				...(props.embedded && {
					width: '100%',
					paddingBottom:
						'calc(10px + env(safe-area-inset-bottom, 0px))',
				}),
				...(props.fixed &&
					!props.embedded && {
						position: 'fixed',
						bottom: 0,
						left: 0,
						right: 0,
						width: '100%',
						zIndex: 1000,
						paddingBottom:
							'calc(10px + env(safe-area-inset-bottom, 0px))',
					}),
			}}
		>
			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				<img
					src={lockIcon}
					alt="lock"
					style={{
						width: mobileScreen ? '16px' : '24px',
						height: mobileScreen ? '16px' : '24px',
						display: 'block',
					}}
				/>
			</Box>

			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				<Typography
					sx={{
						color: '#666666',
						fontSize: mobileScreen ? '0.7rem' : '0.875rem',
						fontFamily: props.customDetails?.fontFamily,
						lineHeight: 1,
					}}
				>
					{t('common.messages.footerDataSharingMessage')}
				</Typography>
			</Box>

			<Box sx={{ display: 'flex', alignItems: 'center' }}>
				<img
					src={finvuLogo}
					alt="Finvu"
					style={{
						width: mobileScreen ? '48px' : '64px',
						objectFit: 'contain',
						display: 'block',
					}}
				/>
			</Box>
		</Box>
	);
};

export default Footer;
